import { BASE_URL } from 'config'
import { keys, omit } from 'lodash'
import { synapse, userPreferencesStore } from 'services/state'

const SELECTED_PROPERTY = {
  ADD: 'ADD',
  REMOVE: 'REMOVE'
}

export const updatePassword = async ({
  currentPassword,
  newPassword,
  repeatPassword
}) => {
  const url = `${BASE_URL}/profile/update_password`
  const body = {
    currentPassword: currentPassword,
    newPassword: newPassword,
    repeatNewPassword: repeatPassword
  }
  return await synapse.fetch(url, { method: 'POST' }, body)
}

const manageSelectedPropertyToObject = (
  userConfig,
  operation = SELECTED_PROPERTY.ADD
) => {
  // add selected property
  const newObj = {
    ...userConfig,
    masterData: {
      ...userConfig?.masterData,
      filteredColumns: keys(userConfig?.masterData?.filteredColumns)?.reduce(
        (acc, inc) => {
          return {
            ...acc,
            [inc]: userConfig?.masterData?.filteredColumns?.[inc]?.map(
              (obj) => {
                return operation === SELECTED_PROPERTY.ADD
                  ? { ...obj, selected: false }
                  : omit(obj, 'selected')
              }
            )
          }
        },
        {}
      )
    },
    output: {
      ...userConfig?.output,
      filteredOutputColumns: keys(
        userConfig?.output?.filteredOutputColumns
      )?.reduce((acc, inc) => {
        return {
          ...acc,
          [inc]: userConfig?.output?.filteredOutputColumns?.[inc]?.map(
            (obj) => {
              return operation === SELECTED_PROPERTY.ADD
                ? { ...obj, selected: false }
                : omit(obj, 'selected')
            }
          )
        }
      }, {})
    }
  }

  return newObj
}

export const getUserDataPreferences = async ({ userId }) => {
  try {
    const url = `${BASE_URL}/user/preferences/${userId}`
    const { body } = await synapse.fetch(url, { method: 'GET' })
    const { userConfig } = body

    const newObj = manageSelectedPropertyToObject(
      userConfig,
      SELECTED_PROPERTY.ADD
    )
    userPreferencesStore.update(() => ({
      ...newObj
    }))
  } catch {
    console.log('get userPref from localstore')

    const userConfigFromLocalStorage =
      JSON.parse(localStorage.getItem('userPreferences')) || {}

    const newObj = manageSelectedPropertyToObject(
      userConfigFromLocalStorage,
      SELECTED_PROPERTY.ADD
    )

    localStorage.setItem('userPreferences', JSON.stringify(newObj))
    userPreferencesStore.update(() => ({
      ...newObj
    }))
  }
}

export const updateUserDataPreferences = async ({
  userId,
  config,
  sendUpdateToServer = true
}) => {
  const updatedPref = {
    ...getUserPreferences(),
    ...config
  }

  userPreferencesStore.update((prevState) => ({
    ...prevState,
    ...updatedPref
  }))
  // update store
  if (sendUpdateToServer) {
    const objectToSave = manageSelectedPropertyToObject(
      updatedPref,
      SELECTED_PROPERTY.REMOVE
    ) // remove selected properties

    try {
      const url = `${BASE_URL}/user/preferences/${userId}`
      const body = {
        userConfig: objectToSave,
        userId: userId
      }
      const { userConfig } = await synapse.fetch(url, { method: 'PUT' }, body)
      // console.log(body)
    } catch (error) {
      console.log('saving userPreferences in localStorage')
      localStorage.setItem('userPreferences', JSON.stringify(updatedPref))
    }
  }
}

export const getUserPreferences = () => userPreferencesStore.get()
